import actions from "@/core/components/SelectCameraSidetask/store/actions";
import mutations from "@/core/components/SelectCameraSidetask/store/mutations";

export default {
  namespaced: true,
  state: {
    sideTaskTypes: null,
  },
  actions,
  mutations,
  getters: {
    getSideTaskTypes(state) {
      return state.sideTaskTypes;
    },
  },
};
